import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getIndustryRecentEpisode } from "../../../actions/industryofweek";
import { getEmployerRecentEpisode } from "../../../actions/employerspotlight";
import { getNotifications } from "../../../actions/notification";
import { logout } from "../../../actions/auth";
import { getCurrentSettings } from "../../../actions/setting";
import { getUsers, clearUsers } from "../../../actions/message";

import ProfileNotifications from "../Innovators/ProfileNotifications";
import MentorNotifications from "../Mentors/MentorNotifications";
import EmployerNotifications from "../Employers/EmployerNotifications";
import MessageUsers from "../Innovators/MessageUsers";
import MessageMentorUsers from "../Mentors/MessageMentorUsers";
import MessageEmployerUsers from "../Employers/MessageEmployerUsers";
import RedLogo from "../Mentors/RedLogo";
import SearchUserItem from "./SearchUserItem";
import IMEAltLogo from "./IMEAltLogo";

const LoggedInNavRed = ({
  auth: { user },
  setting: { settings },
  message: { users },
  getNotifications,
  notification: { notifications },
  logout,
  getUsers,
  getCurrentSettings,
  clearUsers,
  isAuthenticated,
  industryweek: { currentepisode },
  getIndustryRecentEpisode,
  employerweek,
  getEmployerRecentEpisode,
}) => {
  const [profileDropDown, setprofileDropDown] = useState(false);
  const [navLinks, setShowNavLinks] = useState(false);
  const [textValue, setTextValue] = useState("");
  const [overlay, setoverlay] = useState(false);
  const [notificationsOpen, setnotificationsOpen] = useState(false);

  useEffect(() => {
    if (textValue !== "") {
      getUsers(textValue);
    }
  }, [textValue]);

  useEffect(() => {
    getNotifications();
    getCurrentSettings();
    getIndustryRecentEpisode();
    getEmployerRecentEpisode();
  }, [
    getNotifications,
    getIndustryRecentEpisode,
    getEmployerRecentEpisode,
    getCurrentSettings,
  ]);

  return (
    <Fragment>
      {user && user.role === "innovator" && overlay && (
        <MessageUsers setoverlay={setoverlay} />
      )}
      {user && user.role === "mentor" && overlay && (
        <MessageMentorUsers setoverlay={setoverlay} />
      )}
      {user && user.role === "employer" && overlay && (
        <MessageEmployerUsers setoverlay={setoverlay} />
      )}
      <nav>
        <div className="all-nav-container">
          {isAuthenticated && (
            <div className="user-container">
              <Link to={`/${user.channelid}`}>
                <div className="user-avi-container">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                      user && user.avatar
                    }`}
                    className="user-avi"
                  />
                </div>
              </Link>
              <div className="user-name-info-container">
                <p className="user-name-info"> Hi, {user && user.firstname}!</p>
                <div className="arrows-up-down">
                  {!profileDropDown && (
                    <i
                      className={`fas fa-angle-up mx-5 ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : "blue"
                      }`}
                      onClick={() => setprofileDropDown(true)}
                    ></i>
                  )}
                  {profileDropDown && (
                    <i
                      className={`fas fa-angle-down mx-5 ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : "blue"
                      }`}
                      onClick={() => setprofileDropDown(false)}
                    ></i>
                  )}
                </div>
                <i
                  className={
                    notifications.length <= 0
                      ? "far fa-bell red fa-lg mx-10 mt-10"
                      : "fas fa-bell red fa-lg mx-10 mt-10"
                  }
                  onClick={() =>
                    profileDropDown
                      ? setprofileDropDown(false)
                      : setnotificationsOpen(true)
                  }
                ></i>
                {notifications.length > 0 && (
                  <div
                    className="bell-notif-count-alt"
                    onClick={() =>
                      profileDropDown
                        ? setprofileDropDown(false)
                        : setnotificationsOpen(true)
                    }
                  >
                    <span className="fa-stack">
                      <i className="fas fa-circle fa-stack-2x size-alt red"></i>
                      <span className="fa fa-stack-1x up-alt">
                        <span className="white smallest">
                          {notifications.length}
                        </span>
                      </span>
                    </span>
                  </div>
                )}
                <i
                  className="far fa-comments red fa-lg mx-10 mt-10"
                  onClick={() => setoverlay(true)}
                ></i>
                <div
                  className="bell-notif-count"
                  onClick={() => setoverlay(true)}
                >
                  <span className="fa-stack">
                    <i className="fas fa-circle fa-stack-2x size-alt red"></i>
                    <span className="fa fa-stack-1x up-alt">
                      <span className="white smallest">12</span>
                    </span>
                  </span>
                </div>
              </div>
              {notificationsOpen && user && user.role === "innovator" && (
                <ProfileNotifications
                  setnotificationsOpen={setnotificationsOpen}
                  notifications={notifications}
                />
              )}
              {notificationsOpen && user && user.role === "mentor" && (
                <MentorNotifications
                  setnotificationsOpen={setnotificationsOpen}
                  notifications={notifications}
                />
              )}
              {notificationsOpen && user && user.role === "employer" && (
                <EmployerNotifications
                  setnotificationsOpen={setnotificationsOpen}
                  notifications={notifications}
                />
              )}
              {profileDropDown && (
                <div className="profile-drop-down">
                  {user && (
                    <Link to={`/${user.channelid}`}>
                      <div
                        className="profile-drop-container"
                        onClick={() => setprofileDropDown(false)}
                      >
                        <i className="far fa-user-circle fa-lg drop-down-icon red"></i>
                        <p className="drop-down-text">Profile</p>
                      </div>
                    </Link>
                  )}
                  {settings.onlinestatus && settings.onlinestatus.friends && (
                    <div className="profile-drop-container">
                      <i className="fas fa-wifi fa-lg drop-down-icon red"></i>
                      <p className="drop-down-text">Online Status</p>
                      <p className="offline-circle-alt background-red"></p>
                      <p className="drop-down-text">Visible - Friends</p>
                    </div>
                  )}
                  {settings.onlinestatus && settings.onlinestatus.anyone && (
                    <div className="profile-drop-container">
                      <i className="fas fa-wifi fa-lg drop-down-icon red"></i>
                      <p className="drop-down-text">Online Status</p>
                      <p className="offline-circle-alt background-red"></p>
                      <p className="drop-down-text">Visible - All</p>
                    </div>
                  )}
                  {settings.onlinestatus && settings.onlinestatus.hidden && (
                    <div className="profile-drop-container">
                      <i className="fas fa-wifi fa-lg drop-down-icon red"></i>
                      <p className="drop-down-text">Online Status</p>
                      <p className="offline-circle-alt"></p>
                      <p className="drop-down-text">Hidden</p>
                    </div>
                  )}
                  {user && (
                    <Link to={`/${user.channelid}/subscriptions`}>
                      <div className="profile-drop-container">
                        <i className="fas fa-user-check fa-lg drop-down-icon red"></i>
                        <p className="drop-down-text">Subscriptions</p>
                      </div>
                    </Link>
                  )}
                  {user && (
                    <Link to={`/${user.channelid}/settings`}>
                      <div className="profile-drop-container">
                        <i className="fas fa-cog fa-lg drop-down-icon red"></i>
                        <p className="drop-down-text">Settings</p>
                      </div>
                    </Link>
                  )}
                  <div
                    className="profile-drop-container"
                    onClick={logout}
                    href="#!"
                  >
                    <i className="fas fa-door-closed fa-lg drop-down-icon red"></i>
                    <p className="drop-down-text">Logout</p>
                  </div>
                </div>
              )}
            </div>
          )}
          <div className="nav-container">
            <div className="site-name-container">
              <Link to="/">
                <p className="nav-logo">
                  <RedLogo />
                </p>
              </Link>
              <div className="index-logo">
                <IMEAltLogo />
              </div>
              <div className="arrows-up-down">
                {!navLinks && (
                  <i
                    onClick={() => setShowNavLinks(true)}
                    className="fa fa-angle-up fa-lg mx-5 red cursor"
                  ></i>
                )}
                {navLinks && (
                  <i
                    onClick={() => setShowNavLinks(false)}
                    className="fa fa-angle-down fa-lg mx-5 red cursor"
                  ></i>
                )}
              </div>
              {navLinks && (
                <div className="nav-links-drop-down">
                  <Link to="/">
                    <div className="profile-drop-container top-borders">
                      <i className="fas fa-home fa-lg drop-down-icon red mx-5"></i>
                      <p className="drop-down-text red-hover">Home</p>
                    </div>
                  </Link>
                  <Link to={`/industryofweek/${currentepisode.industryname}`}>
                    <div className="profile-drop-container">
                      <i className="fas fa-calendar-week fa-lg drop-down-icon red mx-5"></i>
                      <p className="drop-down-text red-hover">
                        Industry of the Week
                      </p>
                    </div>
                  </Link>
                  <Link to={`/liveonime`}>
                    <div className="profile-drop-container">
                      <i className="fas fa-video fa-lg drop-down-icon red mx-5"></i>
                      <p className="drop-down-text red-hover">Live on ime</p>
                    </div>
                  </Link>
                  <Link
                    to={`/employerspotlight/${employerweek.currentepisode.companyname}`}
                  >
                    <div className="profile-drop-container">
                      <i className="fa-solid fa-lightbulb  fa-lg drop-down-icon red mx-5"></i>
                      <p className="drop-down-text red-hover">
                        Employer Spotlight
                      </p>
                    </div>
                  </Link>
                  <Link to="/vrtours">
                    <div className="profile-drop-container">
                      <i className="fas fa-street-view fa-lg drop-down-icon red mx-5"></i>
                      <p className="drop-down-text red-hover">VR Tours</p>
                    </div>
                  </Link>
                  <Link to="/trending">
                    <div className="profile-drop-container bottom-borders">
                      <i className="fas fa-fire fa-lg drop-down-icon red mx-5"></i>
                      <p className="drop-down-text red-hover">Trending</p>
                    </div>
                  </Link>
                </div>
              )}
            </div>
          </div>
          <form
            className="nav-search hidden-container"
            onSubmit={(e) => {
              e.preventDefault();
              if (textValue !== "") {
                getUsers(textValue);
              }
            }}
          >
            <div className="relative-nav">
              {users && users.length > 0 && textValue !== "" && (
                <i
                  className="far fa-times-circle red mx-5 cursor fa-2x"
                  onClick={() => clearUsers()}
                ></i>
              )}
              <div className="round-input">
                <input
                  type="text"
                  className="search-site"
                  name="imesearch"
                  placeholder="Search..."
                  value={textValue}
                  onChange={(e) => setTextValue(e.target.value)}
                />
                <i
                  className="fas fa-search magnifying red fa-lg cursor"
                  onClick={(e) => {
                    e.preventDefault();
                    if (textValue !== "") {
                      getUsers(textValue);
                    }
                  }}
                ></i>
              </div>
              {users && users.length > 0 && textValue !== "" && (
                <div className="drop-down">
                  {users &&
                    users.map((user) => {
                      return (
                        <SearchUserItem
                          key={user.channelid}
                          user={user}
                          clearUsers={clearUsers}
                        />
                      );
                    })}
                </div>
              )}
            </div>
          </form>
        </div>
      </nav>
    </Fragment>
  );
};

LoggedInNavRed.propTypes = {
  logout: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  getCurrentSettings: PropTypes.func.isRequired,
  clearUsers: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  notification: PropTypes.object.isRequired,
  getIndustryRecentEpisode: PropTypes.func.isRequired,
  getEmployerRecentEpisode: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  setting: state.setting,
  message: state.message,
  industryweek: state.industryweek,
  employerweek: state.employerweek,
  notification: state.notification,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  logout,
  getUsers,
  getCurrentSettings,
  clearUsers,
  getNotifications,
  getIndustryRecentEpisode,
  getEmployerRecentEpisode,
})(LoggedInNavRed);
